import { render } from "./RegistrationSuccessModal.vue?vue&type=template&id=7cace5cb&scoped=true"
import script from "./RegistrationSuccessModal.vue?vue&type=script&lang=js"
export * from "./RegistrationSuccessModal.vue?vue&type=script&lang=js"

import "./RegistrationSuccessModal.vue?vue&type=style&index=0&id=7cace5cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cace5cb"]])

export default __exports__